/**
 * Restyles the native Dawn Quantity fieldset (rendered by
 * product-variant-picker.liquid, completely untouched) into the
 * everstride-style price-boxes for the accessory PDP template only.
 * Reads window.__flowraAccessoryVariantPrices (rendered server-side by
 * flowra-accessory-variant-boxes.liquid) keyed by option value ("1"/"2").
 *
 * Dawn's own product-info.js replaces the ENTIRE <variant-selects>
 * element with a fresh server-rendered copy on every option click (same
 * behavior already documented/handled in flowra-pdp-buybox-extras.liquid
 * for the Find Your Size trigger) -- so this re-runs via the same
 * MutationObserver-on-VARIANT-SELECTS-swap pattern instead of running
 * once at load.
 */
(function () {
  function enhance(root) {
    var fieldsets = root.querySelectorAll('fieldset.product-form__input');
    var qtyFieldset = null;
    Array.prototype.forEach.call(fieldsets, function (fs) {
      var legend = fs.querySelector('legend');
      if (legend && legend.textContent.trim() === 'Quantity') qtyFieldset = fs;
    });
    if (!qtyFieldset) return;

    qtyFieldset.setAttribute('data-flowra-acc-qty', '');

    var prices = window.__flowraAccessoryVariantPrices || {};
    var radios = qtyFieldset.querySelectorAll('input[type="radio"]');
    Array.prototype.forEach.call(radios, function (input) {
      var label = qtyFieldset.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var value = input.value;
      var info = prices[value];
      var unitLabel = value === '1' ? 'Wash Bag' : 'Wash Bags';

      label.innerHTML = '';
      var left = document.createElement('span');
      left.className = 'flowra-acc-box-left';
      var radioDot = document.createElement('span');
      radioDot.className = 'flowra-acc-box-radio';
      radioDot.setAttribute('aria-hidden', 'true');
      var labelText = document.createElement('span');
      labelText.className = 'flowra-acc-box-label';
      labelText.textContent = value + ' ' + unitLabel;
      left.appendChild(radioDot);
      left.appendChild(labelText);
      label.appendChild(left);

      if (info) {
        var right = document.createElement('span');
        right.className = 'flowra-acc-box-right';
        var strong = document.createElement('strong');
        strong.textContent = info.price;
        right.appendChild(strong);
        if (info.hasCompare) {
          var s = document.createElement('s');
          s.textContent = info.compareAtPrice;
          right.appendChild(s);
        }
        label.appendChild(right);
      }
    });

    // "Buy more and save" divider, inserted once as a sibling BEFORE
    // <variant-selects> itself (never touched by Dawn's swap, which only
    // replaces the <variant-selects> element) -- safe to check-and-skip
    // on every enhance() call instead of only the first.
    var variantSelects = qtyFieldset.closest('variant-selects');
    if (variantSelects && variantSelects.parentNode) {
      var already = variantSelects.previousElementSibling;
      if (!already || !already.classList || !already.classList.contains('flowra-acc-buymore')) {
        var divider = document.createElement('div');
        divider.className = 'flowra-acc-buymore';
        var span = document.createElement('span');
        span.textContent = 'Buy more and save';
        divider.appendChild(span);
        variantSelects.parentNode.insertBefore(divider, variantSelects);
      }
    }
  }

  function init() {
    enhance(document);

    var watchRoot = document.querySelector('product-info') || document.body;
    var observer = new MutationObserver(function (mutations) {
      var fresh = null;
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1 && n.tagName === 'VARIANT-SELECTS') fresh = n;
        });
      });
      if (fresh) {
        observer.disconnect();
        enhance(fresh);
        observer.observe(watchRoot, { childList: true, subtree: true });
      }
    });
    observer.observe(watchRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
